'use client';

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { pdpEvaluationOptions } from '@/api/queries/pdpEvaluation';
import { MetaDataParams, PdpEvaluationDTO } from '@/types/models';
export function usePdpEvaluation(): UseQueryResult<PdpEvaluationDTO> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useQuery(pdpEvaluationOptions(id as string));
}